import { BaseItem } from './common';

export type Level = 'error' | 'warn' | 'info' | 'verbose' | 'debug' | 'silly';

export enum PrevisitAuditAction {
  PatientPrevisitAcceptedGeolocation = 'PATIENT_PREVISIT_ACCEPTED_GEOLOCATION',
  PatientPrevisitAuthCodeViewed = 'PATIENT_PREVISIT_AUTH_CODE_VIEWED',
  PatientPrevisitDeclinedGeolocation = 'PATIENT_PREVISIT_DECLINED_GEOLOCATION',
  PatientPrevisitFormSetStarted = 'PATIENT_PREVISIT_FORM_SET_STARTED',
  PatientPrevisitFormSetViewed = 'PATIENT_PREVISIT_FORM_SET_VIEWED',
  PatientPrevisitFormSubmitted = 'PATIENT_PREVISIT_FORM_SUBMITTED',
  PatientPrevisitLogin = 'PATIENT_PREVISIT_LOGIN',
  PatientPrevisitLoginFailed = 'PATIENT_PREVISIT_LOGIN_FAILED',
  PatientPrevisitMessageRequested = 'PATIENT_PREVISIT_MESSAGE_REQUESTED',
  PatientPrevisitMessageRequestFailed = 'PATIENT_PREVISIT_MESSAGE_REQUEST_FAILED',
  PatientPrevisitNavigatedToMessageRequestPage = 'PATIENT_PREVISIT_NAVIGATED_TO_MESSAGE_REQUEST_PAGE',
  PatientPrevisitNavigatedToRegistrationPage = 'PATIENT_PREVISIT_NAVIGATED_TO_REGISTRATION_PAGE',
  PatientPrevisitNavigatedToSignInPage = 'PATIENT_PREVISIT_NAVIGATED_TO_SIGN_IN_PAGE',
  PatientPrevisitNavigatedToConfirmCancelPage = 'PATIENT_PREVISIT_NAVIGATED_TO_CONFIRM_CANCEL_PAGE',
  PatientPrevisitNotificationContentViewed = 'PATIENT_PREVISIT_NOTIFICATION_CONTENT_VIEWED',
  PatientPrevisitPreAuthLogin = 'PATIENT_PREVISIT_PRE_AUTH_LOGIN',
  PatientPrevisitPreAuthLoginFailed = 'PATIENT_PREVISIT_PRE_AUTH_LOGIN_FAILED',
  PatientPrevisitReceiptAuthLogin = 'PATIENT_PREVISIT_RECEIPT_AUTH_LOGIN',
  PatientPrevisitReceiptAuthLoginFailed = 'PATIENT_PREVISIT_RECEIPT_AUTH_LOGIN_FAILED',
  PatientPrevisitSchedulingSlotConfirmationModalTriggered = 'PATIENT_PREVISIT_SCHEDULING_SLOT_CONFIRMATION_MODAL_TRIGGERED',
  PatientPrevisitSchedulingSlotConfirmationModalConfirmed = 'PATIENT_PREVISIT_SCHEDULING_SLOT_CONFIRMATION_MODAL_CONFIRMED',
  PatientPrevisitSchedulingSlotConfirmationModalCanceled = 'PATIENT_PREVISIT_SCHEDULING_SLOT_CONFIRMATION_MODAL_CANCELED',
  PatientPrevisitSchedulingSlotConfirmationModalClosed = 'PATIENT_PREVISIT_SCHEDULING_SLOT_CONFIRMATION_MODAL_CLOSED',
  PatientPrevisitSignedDocuments = 'PATIENT_PREVISIT_SIGNED_DOCUMENTS',
  PatientPrevisitUrlViewed = 'PATIENT_PREVISIT_URL_VIEWED',
}

export enum PrevisitAction {
  AcceptedGeolocation = 'ACCEPTED_GEOLOCATION',
  DeclinedGeolocation = 'DECLINED_GEOLOCATION',
  FailedToSignIn = 'FAILED_TO_SIGN_IN',
  NavigatedToConfirmCancelPage = 'NAVIGATED_TO_CONFIRM_CANCEL_PAGE',
  NavigatedToMessageRequestPage = 'NAVIGATED_TO_MESSAGE_REQUEST_PAGE',
  NavigatedToPreAuthSignInPage = 'NAVIGATED_TO_PRE_AUTH_SIGN_IN_PAGE',
  NavigatedToRegistrationPage = 'NAVIGATED_TO_REGISTRATION_PAGE',
  NavigatedToSignInPage = 'NAVIGATED_TO_SIGN_IN_PAGE',
  SchedulingSlotConfirmationModalTriggered = 'SCHEDULING_SLOT_CONFIRMATION_MODAL_TRIGGERED',
  SchedulingSlotConfirmationModalConfirmed = 'SCHEDULING_SLOT_CONFIRMATION_MODAL_CONFIRMED',
  SchedulingSlotConfirmationModalCanceled = 'SCHEDULING_SLOT_CONFIRMATION_MODAL_CANCELED',
  SchedulingSlotConfirmationModalClosed = 'SCHEDULING_SLOT_CONFIRMATION_MODAL_CLOSED',
  SignedIn = 'SIGNED_IN',
  StartedPrevisitFormSet = 'STARTED_PREVISIT_FORM_SET',
}

export enum AssistantAuditAction {
  AssistantPatientClickedProviderPhoneNumber = 'ASSISTANT_PATIENT_CLICKED_PROVIDER_PHONE_NUMBER',
  AssistantPatientClickedProviderProfile = 'ASSISTANT_PATIENT_CLICKED_PROVIDER_PROFILE',
  AssistantPatientClickedSourceDocument = 'ASSISTANT_PATIENT_CLICKED_SOURCE_DOCUMENT',
  AssistantPatientClickedStaticMap = 'ASSISTANT_PATIENT_CLICKED_STATIC_MAP',
  AssistantVisible = 'ASSISTANT_VISIBLE',
}

export interface LogBase {
  source: string;
  level: Level;
  data: any; // jsonb in postgres
  ip?: string;
  userId?: string; // foreign key to userId
}
export interface Log extends BaseItem, LogBase {}

export interface FindAllOptions {
  source?: string;
  level?: string;
  ip?: string;
  userId?: string;
  after?: Date;
  before?: Date;
  limit?: number;
}
